/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrototypesRouteImport } from './routes/prototypes'
import { Route as LoginLinkModalRouteImport } from './routes/login-link-modal'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PrototypesEmailsRouteImport } from './routes/prototypes/emails'
import { Route as PrototypesCompsRouteImport } from './routes/prototypes/comps'
import { Route as PrototypesCompsConceptsRouteImport } from './routes/prototypes/comps_.concepts'

const LoginLinkLazyRouteImport = createFileRoute('/login-link')()
const LoginLazyRouteImport = createFileRoute('/login')()
const HomeLazyRouteImport = createFileRoute('/home')()
const DemoLazyRouteImport = createFileRoute('/demo')()
const PrototypesIndexLazyRouteImport = createFileRoute('/prototypes/')()
const PrototypesSubmissionsLazyRouteImport = createFileRoute(
  '/prototypes/submissions',
)()
const PrototypesSearchTermsLazyRouteImport = createFileRoute(
  '/prototypes/search-terms',
)()
const PrototypesProvenanceLazyRouteImport = createFileRoute(
  '/prototypes/provenance',
)()
const PrototypesPresenceLazyRouteImport = createFileRoute(
  '/prototypes/presence',
)()
const PrototypesOutboxLazyRouteImport = createFileRoute('/prototypes/outbox')()
const PrototypesManuscriptInboxLazyRouteImport = createFileRoute(
  '/prototypes/manuscript-inbox',
)()
const PrototypesJourneyLazyRouteImport = createFileRoute(
  '/prototypes/journey',
)()
const PrototypesInnovationDaysDemoLazyRouteImport = createFileRoute(
  '/prototypes/innovation-days-demo',
)()
const PrototypesBookboundLazyRouteImport = createFileRoute(
  '/prototypes/bookbound',
)()
const PrototypesSubmissionsIdLazyRouteImport = createFileRoute(
  '/prototypes/submissions_/$id',
)()
const PrototypesSearchTermsIsbnLazyRouteImport = createFileRoute(
  '/prototypes/search-terms_/$isbn',
)()
const PrototypesProvenanceIdLazyRouteImport = createFileRoute(
  '/prototypes/provenance_/$id',
)()
const PrototypesPresenceIdLazyRouteImport = createFileRoute(
  '/prototypes/presence_/$id',
)()
const PrototypesManuscriptInboxIdLazyRouteImport = createFileRoute(
  '/prototypes/manuscript-inbox_/$id',
)()
const PrototypesJourneyThreadIdLazyRouteImport = createFileRoute(
  '/prototypes/journey_/$threadId',
)()
const PrototypesBookboundIdLazyRouteImport = createFileRoute(
  '/prototypes/bookbound_/$id',
)()

const LoginLinkLazyRoute = LoginLinkLazyRouteImport.update({
  id: '/login-link',
  path: '/login-link',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login-link.lazy').then((d) => d.Route))
const LoginLazyRoute = LoginLazyRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const HomeLazyRoute = HomeLazyRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/home.lazy').then((d) => d.Route))
const DemoLazyRoute = DemoLazyRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/demo.lazy').then((d) => d.Route))
const PrototypesRoute = PrototypesRouteImport.update({
  id: '/prototypes',
  path: '/prototypes',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginLinkModalRoute = LoginLinkModalRouteImport.update({
  id: '/login-link-modal',
  path: '/login-link-modal',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypesIndexLazyRoute = PrototypesIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrototypesRoute,
} as any).lazy(() =>
  import('./routes/prototypes/index.lazy').then((d) => d.Route),
)
const PrototypesSubmissionsLazyRoute =
  PrototypesSubmissionsLazyRouteImport.update({
    id: '/submissions',
    path: '/submissions',
    getParentRoute: () => PrototypesRoute,
  } as any).lazy(() =>
    import('./routes/prototypes/submissions.lazy').then((d) => d.Route),
  )
const PrototypesSearchTermsLazyRoute =
  PrototypesSearchTermsLazyRouteImport.update({
    id: '/search-terms',
    path: '/search-terms',
    getParentRoute: () => PrototypesRoute,
  } as any).lazy(() =>
    import('./routes/prototypes/search-terms.lazy').then((d) => d.Route),
  )
const PrototypesProvenanceLazyRoute =
  PrototypesProvenanceLazyRouteImport.update({
    id: '/provenance',
    path: '/provenance',
    getParentRoute: () => PrototypesRoute,
  } as any).lazy(() =>
    import('./routes/prototypes/provenance.lazy').then((d) => d.Route),
  )
const PrototypesPresenceLazyRoute = PrototypesPresenceLazyRouteImport.update({
  id: '/presence',
  path: '/presence',
  getParentRoute: () => PrototypesRoute,
} as any).lazy(() =>
  import('./routes/prototypes/presence.lazy').then((d) => d.Route),
)
const PrototypesOutboxLazyRoute = PrototypesOutboxLazyRouteImport.update({
  id: '/outbox',
  path: '/outbox',
  getParentRoute: () => PrototypesRoute,
} as any).lazy(() =>
  import('./routes/prototypes/outbox.lazy').then((d) => d.Route),
)
const PrototypesManuscriptInboxLazyRoute =
  PrototypesManuscriptInboxLazyRouteImport.update({
    id: '/manuscript-inbox',
    path: '/manuscript-inbox',
    getParentRoute: () => PrototypesRoute,
  } as any).lazy(() =>
    import('./routes/prototypes/manuscript-inbox.lazy').then((d) => d.Route),
  )
const PrototypesJourneyLazyRoute = PrototypesJourneyLazyRouteImport.update({
  id: '/journey',
  path: '/journey',
  getParentRoute: () => PrototypesRoute,
} as any).lazy(() =>
  import('./routes/prototypes/journey.lazy').then((d) => d.Route),
)
const PrototypesInnovationDaysDemoLazyRoute =
  PrototypesInnovationDaysDemoLazyRouteImport.update({
    id: '/innovation-days-demo',
    path: '/innovation-days-demo',
    getParentRoute: () => PrototypesRoute,
  } as any).lazy(() =>
    import('./routes/prototypes/innovation-days-demo.lazy').then(
      (d) => d.Route,
    ),
  )
const PrototypesBookboundLazyRoute = PrototypesBookboundLazyRouteImport.update({
  id: '/bookbound',
  path: '/bookbound',
  getParentRoute: () => PrototypesRoute,
} as any).lazy(() =>
  import('./routes/prototypes/bookbound.lazy').then((d) => d.Route),
)
const PrototypesEmailsRoute = PrototypesEmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => PrototypesRoute,
} as any).lazy(() =>
  import('./routes/prototypes/emails.lazy').then((d) => d.Route),
)
const PrototypesCompsRoute = PrototypesCompsRouteImport.update({
  id: '/comps',
  path: '/comps',
  getParentRoute: () => PrototypesRoute,
} as any).lazy(() =>
  import('./routes/prototypes/comps.lazy').then((d) => d.Route),
)
const PrototypesSubmissionsIdLazyRoute =
  PrototypesSubmissionsIdLazyRouteImport.update({
    id: '/submissions_/$id',
    path: '/submissions/$id',
    getParentRoute: () => PrototypesRoute,
  } as any).lazy(() =>
    import('./routes/prototypes/submissions_.$id.lazy').then((d) => d.Route),
  )
const PrototypesSearchTermsIsbnLazyRoute =
  PrototypesSearchTermsIsbnLazyRouteImport.update({
    id: '/search-terms_/$isbn',
    path: '/search-terms/$isbn',
    getParentRoute: () => PrototypesRoute,
  } as any).lazy(() =>
    import('./routes/prototypes/search-terms_.$isbn.lazy').then((d) => d.Route),
  )
const PrototypesProvenanceIdLazyRoute =
  PrototypesProvenanceIdLazyRouteImport.update({
    id: '/provenance_/$id',
    path: '/provenance/$id',
    getParentRoute: () => PrototypesRoute,
  } as any).lazy(() =>
    import('./routes/prototypes/provenance_.$id.lazy').then((d) => d.Route),
  )
const PrototypesPresenceIdLazyRoute =
  PrototypesPresenceIdLazyRouteImport.update({
    id: '/presence_/$id',
    path: '/presence/$id',
    getParentRoute: () => PrototypesRoute,
  } as any).lazy(() =>
    import('./routes/prototypes/presence_.$id.lazy').then((d) => d.Route),
  )
const PrototypesManuscriptInboxIdLazyRoute =
  PrototypesManuscriptInboxIdLazyRouteImport.update({
    id: '/manuscript-inbox_/$id',
    path: '/manuscript-inbox/$id',
    getParentRoute: () => PrototypesRoute,
  } as any).lazy(() =>
    import('./routes/prototypes/manuscript-inbox_.$id.lazy').then(
      (d) => d.Route,
    ),
  )
const PrototypesJourneyThreadIdLazyRoute =
  PrototypesJourneyThreadIdLazyRouteImport.update({
    id: '/journey_/$threadId',
    path: '/journey/$threadId',
    getParentRoute: () => PrototypesRoute,
  } as any).lazy(() =>
    import('./routes/prototypes/journey_.$threadId.lazy').then((d) => d.Route),
  )
const PrototypesBookboundIdLazyRoute =
  PrototypesBookboundIdLazyRouteImport.update({
    id: '/bookbound_/$id',
    path: '/bookbound/$id',
    getParentRoute: () => PrototypesRoute,
  } as any).lazy(() =>
    import('./routes/prototypes/bookbound_.$id.lazy').then((d) => d.Route),
  )
const PrototypesCompsConceptsRoute = PrototypesCompsConceptsRouteImport.update({
  id: '/comps_/concepts',
  path: '/comps/concepts',
  getParentRoute: () => PrototypesRoute,
} as any).lazy(() =>
  import('./routes/prototypes/comps_.concepts.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login-link-modal': typeof LoginLinkModalRoute
  '/prototypes': typeof PrototypesRouteWithChildren
  '/demo': typeof DemoLazyRoute
  '/home': typeof HomeLazyRoute
  '/login': typeof LoginLazyRoute
  '/login-link': typeof LoginLinkLazyRoute
  '/prototypes/comps': typeof PrototypesCompsRoute
  '/prototypes/emails': typeof PrototypesEmailsRoute
  '/prototypes/bookbound': typeof PrototypesBookboundLazyRoute
  '/prototypes/innovation-days-demo': typeof PrototypesInnovationDaysDemoLazyRoute
  '/prototypes/journey': typeof PrototypesJourneyLazyRoute
  '/prototypes/manuscript-inbox': typeof PrototypesManuscriptInboxLazyRoute
  '/prototypes/outbox': typeof PrototypesOutboxLazyRoute
  '/prototypes/presence': typeof PrototypesPresenceLazyRoute
  '/prototypes/provenance': typeof PrototypesProvenanceLazyRoute
  '/prototypes/search-terms': typeof PrototypesSearchTermsLazyRoute
  '/prototypes/submissions': typeof PrototypesSubmissionsLazyRoute
  '/prototypes/': typeof PrototypesIndexLazyRoute
  '/prototypes/comps/concepts': typeof PrototypesCompsConceptsRoute
  '/prototypes/bookbound/$id': typeof PrototypesBookboundIdLazyRoute
  '/prototypes/journey/$threadId': typeof PrototypesJourneyThreadIdLazyRoute
  '/prototypes/manuscript-inbox/$id': typeof PrototypesManuscriptInboxIdLazyRoute
  '/prototypes/presence/$id': typeof PrototypesPresenceIdLazyRoute
  '/prototypes/provenance/$id': typeof PrototypesProvenanceIdLazyRoute
  '/prototypes/search-terms/$isbn': typeof PrototypesSearchTermsIsbnLazyRoute
  '/prototypes/submissions/$id': typeof PrototypesSubmissionsIdLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login-link-modal': typeof LoginLinkModalRoute
  '/demo': typeof DemoLazyRoute
  '/home': typeof HomeLazyRoute
  '/login': typeof LoginLazyRoute
  '/login-link': typeof LoginLinkLazyRoute
  '/prototypes/comps': typeof PrototypesCompsRoute
  '/prototypes/emails': typeof PrototypesEmailsRoute
  '/prototypes/bookbound': typeof PrototypesBookboundLazyRoute
  '/prototypes/innovation-days-demo': typeof PrototypesInnovationDaysDemoLazyRoute
  '/prototypes/journey': typeof PrototypesJourneyLazyRoute
  '/prototypes/manuscript-inbox': typeof PrototypesManuscriptInboxLazyRoute
  '/prototypes/outbox': typeof PrototypesOutboxLazyRoute
  '/prototypes/presence': typeof PrototypesPresenceLazyRoute
  '/prototypes/provenance': typeof PrototypesProvenanceLazyRoute
  '/prototypes/search-terms': typeof PrototypesSearchTermsLazyRoute
  '/prototypes/submissions': typeof PrototypesSubmissionsLazyRoute
  '/prototypes': typeof PrototypesIndexLazyRoute
  '/prototypes/comps/concepts': typeof PrototypesCompsConceptsRoute
  '/prototypes/bookbound/$id': typeof PrototypesBookboundIdLazyRoute
  '/prototypes/journey/$threadId': typeof PrototypesJourneyThreadIdLazyRoute
  '/prototypes/manuscript-inbox/$id': typeof PrototypesManuscriptInboxIdLazyRoute
  '/prototypes/presence/$id': typeof PrototypesPresenceIdLazyRoute
  '/prototypes/provenance/$id': typeof PrototypesProvenanceIdLazyRoute
  '/prototypes/search-terms/$isbn': typeof PrototypesSearchTermsIsbnLazyRoute
  '/prototypes/submissions/$id': typeof PrototypesSubmissionsIdLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login-link-modal': typeof LoginLinkModalRoute
  '/prototypes': typeof PrototypesRouteWithChildren
  '/demo': typeof DemoLazyRoute
  '/home': typeof HomeLazyRoute
  '/login': typeof LoginLazyRoute
  '/login-link': typeof LoginLinkLazyRoute
  '/prototypes/comps': typeof PrototypesCompsRoute
  '/prototypes/emails': typeof PrototypesEmailsRoute
  '/prototypes/bookbound': typeof PrototypesBookboundLazyRoute
  '/prototypes/innovation-days-demo': typeof PrototypesInnovationDaysDemoLazyRoute
  '/prototypes/journey': typeof PrototypesJourneyLazyRoute
  '/prototypes/manuscript-inbox': typeof PrototypesManuscriptInboxLazyRoute
  '/prototypes/outbox': typeof PrototypesOutboxLazyRoute
  '/prototypes/presence': typeof PrototypesPresenceLazyRoute
  '/prototypes/provenance': typeof PrototypesProvenanceLazyRoute
  '/prototypes/search-terms': typeof PrototypesSearchTermsLazyRoute
  '/prototypes/submissions': typeof PrototypesSubmissionsLazyRoute
  '/prototypes/': typeof PrototypesIndexLazyRoute
  '/prototypes/comps_/concepts': typeof PrototypesCompsConceptsRoute
  '/prototypes/bookbound_/$id': typeof PrototypesBookboundIdLazyRoute
  '/prototypes/journey_/$threadId': typeof PrototypesJourneyThreadIdLazyRoute
  '/prototypes/manuscript-inbox_/$id': typeof PrototypesManuscriptInboxIdLazyRoute
  '/prototypes/presence_/$id': typeof PrototypesPresenceIdLazyRoute
  '/prototypes/provenance_/$id': typeof PrototypesProvenanceIdLazyRoute
  '/prototypes/search-terms_/$isbn': typeof PrototypesSearchTermsIsbnLazyRoute
  '/prototypes/submissions_/$id': typeof PrototypesSubmissionsIdLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login-link-modal'
    | '/prototypes'
    | '/demo'
    | '/home'
    | '/login'
    | '/login-link'
    | '/prototypes/comps'
    | '/prototypes/emails'
    | '/prototypes/bookbound'
    | '/prototypes/innovation-days-demo'
    | '/prototypes/journey'
    | '/prototypes/manuscript-inbox'
    | '/prototypes/outbox'
    | '/prototypes/presence'
    | '/prototypes/provenance'
    | '/prototypes/search-terms'
    | '/prototypes/submissions'
    | '/prototypes/'
    | '/prototypes/comps/concepts'
    | '/prototypes/bookbound/$id'
    | '/prototypes/journey/$threadId'
    | '/prototypes/manuscript-inbox/$id'
    | '/prototypes/presence/$id'
    | '/prototypes/provenance/$id'
    | '/prototypes/search-terms/$isbn'
    | '/prototypes/submissions/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login-link-modal'
    | '/demo'
    | '/home'
    | '/login'
    | '/login-link'
    | '/prototypes/comps'
    | '/prototypes/emails'
    | '/prototypes/bookbound'
    | '/prototypes/innovation-days-demo'
    | '/prototypes/journey'
    | '/prototypes/manuscript-inbox'
    | '/prototypes/outbox'
    | '/prototypes/presence'
    | '/prototypes/provenance'
    | '/prototypes/search-terms'
    | '/prototypes/submissions'
    | '/prototypes'
    | '/prototypes/comps/concepts'
    | '/prototypes/bookbound/$id'
    | '/prototypes/journey/$threadId'
    | '/prototypes/manuscript-inbox/$id'
    | '/prototypes/presence/$id'
    | '/prototypes/provenance/$id'
    | '/prototypes/search-terms/$isbn'
    | '/prototypes/submissions/$id'
  id:
    | '__root__'
    | '/'
    | '/login-link-modal'
    | '/prototypes'
    | '/demo'
    | '/home'
    | '/login'
    | '/login-link'
    | '/prototypes/comps'
    | '/prototypes/emails'
    | '/prototypes/bookbound'
    | '/prototypes/innovation-days-demo'
    | '/prototypes/journey'
    | '/prototypes/manuscript-inbox'
    | '/prototypes/outbox'
    | '/prototypes/presence'
    | '/prototypes/provenance'
    | '/prototypes/search-terms'
    | '/prototypes/submissions'
    | '/prototypes/'
    | '/prototypes/comps_/concepts'
    | '/prototypes/bookbound_/$id'
    | '/prototypes/journey_/$threadId'
    | '/prototypes/manuscript-inbox_/$id'
    | '/prototypes/presence_/$id'
    | '/prototypes/provenance_/$id'
    | '/prototypes/search-terms_/$isbn'
    | '/prototypes/submissions_/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginLinkModalRoute: typeof LoginLinkModalRoute
  PrototypesRoute: typeof PrototypesRouteWithChildren
  DemoLazyRoute: typeof DemoLazyRoute
  HomeLazyRoute: typeof HomeLazyRoute
  LoginLazyRoute: typeof LoginLazyRoute
  LoginLinkLazyRoute: typeof LoginLinkLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login-link': {
      id: '/login-link'
      path: '/login-link'
      fullPath: '/login-link'
      preLoaderRoute: typeof LoginLinkLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes': {
      id: '/prototypes'
      path: '/prototypes'
      fullPath: '/prototypes'
      preLoaderRoute: typeof PrototypesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-link-modal': {
      id: '/login-link-modal'
      path: '/login-link-modal'
      fullPath: '/login-link-modal'
      preLoaderRoute: typeof LoginLinkModalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/': {
      id: '/prototypes/'
      path: '/'
      fullPath: '/prototypes/'
      preLoaderRoute: typeof PrototypesIndexLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/submissions': {
      id: '/prototypes/submissions'
      path: '/submissions'
      fullPath: '/prototypes/submissions'
      preLoaderRoute: typeof PrototypesSubmissionsLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/search-terms': {
      id: '/prototypes/search-terms'
      path: '/search-terms'
      fullPath: '/prototypes/search-terms'
      preLoaderRoute: typeof PrototypesSearchTermsLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/provenance': {
      id: '/prototypes/provenance'
      path: '/provenance'
      fullPath: '/prototypes/provenance'
      preLoaderRoute: typeof PrototypesProvenanceLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/presence': {
      id: '/prototypes/presence'
      path: '/presence'
      fullPath: '/prototypes/presence'
      preLoaderRoute: typeof PrototypesPresenceLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/outbox': {
      id: '/prototypes/outbox'
      path: '/outbox'
      fullPath: '/prototypes/outbox'
      preLoaderRoute: typeof PrototypesOutboxLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/manuscript-inbox': {
      id: '/prototypes/manuscript-inbox'
      path: '/manuscript-inbox'
      fullPath: '/prototypes/manuscript-inbox'
      preLoaderRoute: typeof PrototypesManuscriptInboxLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/journey': {
      id: '/prototypes/journey'
      path: '/journey'
      fullPath: '/prototypes/journey'
      preLoaderRoute: typeof PrototypesJourneyLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/innovation-days-demo': {
      id: '/prototypes/innovation-days-demo'
      path: '/innovation-days-demo'
      fullPath: '/prototypes/innovation-days-demo'
      preLoaderRoute: typeof PrototypesInnovationDaysDemoLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/bookbound': {
      id: '/prototypes/bookbound'
      path: '/bookbound'
      fullPath: '/prototypes/bookbound'
      preLoaderRoute: typeof PrototypesBookboundLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/emails': {
      id: '/prototypes/emails'
      path: '/emails'
      fullPath: '/prototypes/emails'
      preLoaderRoute: typeof PrototypesEmailsRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/comps': {
      id: '/prototypes/comps'
      path: '/comps'
      fullPath: '/prototypes/comps'
      preLoaderRoute: typeof PrototypesCompsRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/submissions_/$id': {
      id: '/prototypes/submissions_/$id'
      path: '/submissions/$id'
      fullPath: '/prototypes/submissions/$id'
      preLoaderRoute: typeof PrototypesSubmissionsIdLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/search-terms_/$isbn': {
      id: '/prototypes/search-terms_/$isbn'
      path: '/search-terms/$isbn'
      fullPath: '/prototypes/search-terms/$isbn'
      preLoaderRoute: typeof PrototypesSearchTermsIsbnLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/provenance_/$id': {
      id: '/prototypes/provenance_/$id'
      path: '/provenance/$id'
      fullPath: '/prototypes/provenance/$id'
      preLoaderRoute: typeof PrototypesProvenanceIdLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/presence_/$id': {
      id: '/prototypes/presence_/$id'
      path: '/presence/$id'
      fullPath: '/prototypes/presence/$id'
      preLoaderRoute: typeof PrototypesPresenceIdLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/manuscript-inbox_/$id': {
      id: '/prototypes/manuscript-inbox_/$id'
      path: '/manuscript-inbox/$id'
      fullPath: '/prototypes/manuscript-inbox/$id'
      preLoaderRoute: typeof PrototypesManuscriptInboxIdLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/journey_/$threadId': {
      id: '/prototypes/journey_/$threadId'
      path: '/journey/$threadId'
      fullPath: '/prototypes/journey/$threadId'
      preLoaderRoute: typeof PrototypesJourneyThreadIdLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/bookbound_/$id': {
      id: '/prototypes/bookbound_/$id'
      path: '/bookbound/$id'
      fullPath: '/prototypes/bookbound/$id'
      preLoaderRoute: typeof PrototypesBookboundIdLazyRouteImport
      parentRoute: typeof PrototypesRoute
    }
    '/prototypes/comps_/concepts': {
      id: '/prototypes/comps_/concepts'
      path: '/comps/concepts'
      fullPath: '/prototypes/comps/concepts'
      preLoaderRoute: typeof PrototypesCompsConceptsRouteImport
      parentRoute: typeof PrototypesRoute
    }
  }
}

interface PrototypesRouteChildren {
  PrototypesCompsRoute: typeof PrototypesCompsRoute
  PrototypesEmailsRoute: typeof PrototypesEmailsRoute
  PrototypesBookboundLazyRoute: typeof PrototypesBookboundLazyRoute
  PrototypesInnovationDaysDemoLazyRoute: typeof PrototypesInnovationDaysDemoLazyRoute
  PrototypesJourneyLazyRoute: typeof PrototypesJourneyLazyRoute
  PrototypesManuscriptInboxLazyRoute: typeof PrototypesManuscriptInboxLazyRoute
  PrototypesOutboxLazyRoute: typeof PrototypesOutboxLazyRoute
  PrototypesPresenceLazyRoute: typeof PrototypesPresenceLazyRoute
  PrototypesProvenanceLazyRoute: typeof PrototypesProvenanceLazyRoute
  PrototypesSearchTermsLazyRoute: typeof PrototypesSearchTermsLazyRoute
  PrototypesSubmissionsLazyRoute: typeof PrototypesSubmissionsLazyRoute
  PrototypesIndexLazyRoute: typeof PrototypesIndexLazyRoute
  PrototypesCompsConceptsRoute: typeof PrototypesCompsConceptsRoute
  PrototypesBookboundIdLazyRoute: typeof PrototypesBookboundIdLazyRoute
  PrototypesJourneyThreadIdLazyRoute: typeof PrototypesJourneyThreadIdLazyRoute
  PrototypesManuscriptInboxIdLazyRoute: typeof PrototypesManuscriptInboxIdLazyRoute
  PrototypesPresenceIdLazyRoute: typeof PrototypesPresenceIdLazyRoute
  PrototypesProvenanceIdLazyRoute: typeof PrototypesProvenanceIdLazyRoute
  PrototypesSearchTermsIsbnLazyRoute: typeof PrototypesSearchTermsIsbnLazyRoute
  PrototypesSubmissionsIdLazyRoute: typeof PrototypesSubmissionsIdLazyRoute
}

const PrototypesRouteChildren: PrototypesRouteChildren = {
  PrototypesCompsRoute: PrototypesCompsRoute,
  PrototypesEmailsRoute: PrototypesEmailsRoute,
  PrototypesBookboundLazyRoute: PrototypesBookboundLazyRoute,
  PrototypesInnovationDaysDemoLazyRoute: PrototypesInnovationDaysDemoLazyRoute,
  PrototypesJourneyLazyRoute: PrototypesJourneyLazyRoute,
  PrototypesManuscriptInboxLazyRoute: PrototypesManuscriptInboxLazyRoute,
  PrototypesOutboxLazyRoute: PrototypesOutboxLazyRoute,
  PrototypesPresenceLazyRoute: PrototypesPresenceLazyRoute,
  PrototypesProvenanceLazyRoute: PrototypesProvenanceLazyRoute,
  PrototypesSearchTermsLazyRoute: PrototypesSearchTermsLazyRoute,
  PrototypesSubmissionsLazyRoute: PrototypesSubmissionsLazyRoute,
  PrototypesIndexLazyRoute: PrototypesIndexLazyRoute,
  PrototypesCompsConceptsRoute: PrototypesCompsConceptsRoute,
  PrototypesBookboundIdLazyRoute: PrototypesBookboundIdLazyRoute,
  PrototypesJourneyThreadIdLazyRoute: PrototypesJourneyThreadIdLazyRoute,
  PrototypesManuscriptInboxIdLazyRoute: PrototypesManuscriptInboxIdLazyRoute,
  PrototypesPresenceIdLazyRoute: PrototypesPresenceIdLazyRoute,
  PrototypesProvenanceIdLazyRoute: PrototypesProvenanceIdLazyRoute,
  PrototypesSearchTermsIsbnLazyRoute: PrototypesSearchTermsIsbnLazyRoute,
  PrototypesSubmissionsIdLazyRoute: PrototypesSubmissionsIdLazyRoute,
}

const PrototypesRouteWithChildren = PrototypesRoute._addFileChildren(
  PrototypesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginLinkModalRoute: LoginLinkModalRoute,
  PrototypesRoute: PrototypesRouteWithChildren,
  DemoLazyRoute: DemoLazyRoute,
  HomeLazyRoute: HomeLazyRoute,
  LoginLazyRoute: LoginLazyRoute,
  LoginLinkLazyRoute: LoginLinkLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
